<template lang="pug">
  div
    page-preloader
    .map-container.navigation-control.routes
      auto-route(
        :tkoObjects="tkoObjects"
        ref="autoRoute"
        @routesGenerated="routesGenerated"
      )
      .routes__toolbar
        e-toolbar(
          :hideRemoveButton="true"
          :showTotal="true"
          :hideSearch="true"
          :hideAddButton="true"
          :showViewPanel="false"
          :showExport="hasRouteImportExport"
          :endpointExport="getExportPoint"
        )
      .map.absolute#map(ref="map" v-once)
      div
        .legend.routes__legend.opened(v-if="openedRoute && openedRoute.id")
          .legend__head.routes__head
            h2.legend__title Изменение маршрута
            button.legend__close.reset-btn(@click="closeRoute()")
          .legend__group(:class="{'pointer-none': !userCanEdit}")
            .legend__type
              .routes__block
                label.label.semibold Номер маршрута
                input.input.input_wide(v-model="openedRoute.name" type="number" @input="changeField")
          .legend__group(v-if='hasRouteRegionalOperator' )
            .legend__type
              .routes__block
                label.label.semibold Региональный оператор
                e-select(
                  name="tko_operator_regional_id"
                  :model="openedRoute"
                  :options='tkoRegionalOperators'
                )
          .legend__group(v-if='hasRouteOperator' )
            .legend__type
              .routes__block
                label.label.semibold Транспортировщик
                e-select(
                  name="tko_operator_transporter_id"
                  :model="openedRoute"
                  :options='tkoOperators'
                )
          .legend__group
            .legend__type(:class="{'pointer-none': !userCanEdit}")
              .line
                .line__item
                  span.line__prop Протяженность (км):
                  span.line__value {{openedRoute.distance}}
                .line__item
                  span.line__prop Приблизительное время:
                  span.line__value {{openedRoute.duration}}
                .line__item
                  span.line__prop Стоимость:
                  span.line__value {{openedRoute.cost}}
          .legend__group
            .legend__type
              .routes__block
                label.label.semibold Масса, тонн:
                input.input.input_wide(
                  value="5"
                  v-model="openedRoute.mass"
                  name="mass"
                  @input="changeField"
                )
          .legend__group.routes__calculate
            .legend__type
              button.button.reset-btn(
                v-if="hasTransportChoose"
                :class="{'pointer-none': !userCanEdit}"
                @click="showTransportModal = !showTransportModal"
              ) Расчет оптимальных ТС
            transport-choose(
              v-if="showTransportModal"
              :class="{'pointer-none': !userCanEdit}"
              @close='showTransportModal = false'
              :routeId="openedRoute.id"
            )
          map-fkko(
            v-if="hasFkkoFilter",
            @updateSearch="updateFkko"
            :class="{'pointer-none': !userCanEdit}"
          )
          map-danger-class(
            v-if="hasFkkoFilter"
            @updateDangerClass="updateDangerClass"
            :class="{'pointer-none': !userCanEdit}"
          )
          .legend__group
            .legend__type.legend__type_with-small(:class="{'pointer-none': !userCanEdit}")
              .legend__name.semibold Периодичность маршрута
            .legend__small-group
              e-radio(
                name="period_id"
                :options="routePeriods"
                :model="openedRoute"
                tabView="tab1"
                @change="changeField"
              )
            .legend__small-group(v-if="openedRoute.period_id === PERIOD_WEEKLY")
              .legend__name.semibold День недели
              .custom-radio
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="1"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Пн
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="2"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Вт
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="3"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Ср
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="4"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Чт
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="5"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Пт
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="6"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Сб
                label.custom-radio__item.custom-radio__label
                  input.custom-radio__input.visually-hidden(
                    value="7"
                    v-model="openedRoute.weekday_id"
                    type="radio"
                    name="weekday_id"
                  )
                  .custom-radio__block
                  .custom-radio__text Вс
          .legend__group
            .legend__type
              .legend__name.semibold Период действия
            .legend__small-group
              e-form(:formValidator="formValidator")
                e-form-group(
                  name="date_start"
                  inputType="calendar"
                  label="Дата начала"
                  :model="openedRoute"
                  type="date"
                  @changeCalendar="changeField"
                  tabView="tab1"
                )
                e-form-group(
                  name="date_finish"
                  inputType="calendar"
                  label="Дата окончания"
                  :model="openedRoute"
                  @changeCalendar="changeField"
                  type="date"
                  tabView="tab1"
                )
          .legend__group(:class="{'pointer-none': !userCanEdit}")
            .legend__type
              e-form(:formValidator="formValidator")
                e-form-group(
                  class="e-form-group"
                  name="start_point_address"
                  inputType="address"
                  label="Начальная точка"
                  :model="openedRoute"
                  tabView="tab1"
                  :required="true"
                  :addressData="addressData"
                  :addressProvider="'dadata'"
                  @selectItem="onSelectAddress"
                )
          route-objects(
            :objectList="objectList"
            :objectAddress="openedRoute.end_point_address"
            @updateSearch="updateObjects"
          )
          .legend__group
            .legend__type.legend__type_with-small
            .legend__small-group
              button(@click.stop.prevent="addPoint" :disabled='waitForPoint').reset-btn.button.button_add.button_icon-text.routes__add
                span Добавить адреса
            .legend__small-group(v-if="calcEnable === true")
              button(@click.stop.prevent="calcRoute" ).reset-btn.button.button_usual.button_no-border.button_calculate.button_icon-text
                span Рассчитать маршрут
            .legend__small-group(v-if="saving === false && saveEnable === true")
              button(@click.stop.prevent="saveRoute").reset-btn.button.button_usual.button_no-border.button_save.button_icon-text
                span Сохранить
            .legend__small-group( v-if="saving === true")
              button(@click.stop.prevent="").reset-btn.button.button_usual.button_no-border.button_refresh.button_icon-text
                span Сохранение...
          map-msn(
            v-if="hasRouteContainerType"
            @updateSearch="updateMsn"
            :searchType="msnSearchType"
            :class="{'pointer-none': !userCanEdit}"
          )
          search-msn(
            @updateSearch="searchMsn"
            :class="{'pointer-none': !userCanEdit}"
          )
          .legend__group
            .legend__type
              table.routes__table
                thead
                  th №
                  th Адрес
                  th Количество
                  th Объем куб.м.
                  th
                tbody(
                  v-if="openedRoute.startPoint && openedRoute.start_point_address"
                )
                  tr.routes__table-row(
                    class="hovered"
                    title="Начальная точка - гараж"
                    @click="zoomToPoint(openedRoute.startPoint)"
                  )
                    td.routes__table-col
                      img(:src="GarageImage" style="width:20px")
                    td.routes__table-col {{openedRoute.start_point_address}}
                    td.routes__table-col -
                    td.routes__table-col -
                    td.routes__table-col -
                tbody(
                  v-if="Object.keys(routeMsns).length"
                  is="transition-group"
                  name="flip-list"
                )
                  tr.routes__table-row(
                    class="hovered"
                    v-for="(point, index) in routePointList"
                    :key="index"
                    @click="zoomToPoint(point)"
                  )
                    td.routes__table-col(align="center") {{(index + 1)}}
                    td.routes__table-col {{point.streetWithNumber || point.name}} {{point.address}}
                    td.routes__table-col {{point.containers_count || ' - '}}
                    td.routes__table-col {{point.containersVolumeSum || ' - '}}
                    td.routes__table-col
                      button(
                        v-if="userCanDelete"
                        @click.stop.prevent="removePoint(index)"
                      ).reset-btn.close
                tbody(v-else)
                  tr.routes__table-row
                    td(colspan=100) нет адресов контейнерных площадок
                tbody(
                  v-if="openedRoute.tkoPoints"
                )
                  tr.routes__table-row(
                    class="hovered"
                    v-for="(point, index) in routeTkoList"
                    :key="index"
                    @click="zoomToPoint(point)"
                  )
                    td.routes__table-col(align="center") {{(routePointList.length + index + 1)}}
                    td.routes__table-col {{point.streetWithNumber || point.name}}
                    td.routes__table-col {{point.containers_count || ' - '}}
                    td.routes__table-col {{point.containersVolumeSum || ' - '}}
                    td.routes__table-col
                      button(
                        v-if="userCanEdit"
                        @click.stop.prevent="removeTkoPoint(index)"
                      ).reset-btn.close
                tbody(
                  v-if="openedRoute.endPoint && openedRoute.endPoint.address"
                )
                  tr.routes__table-row(
                    class="hovered"
                    title="Конечная точка - объект размещения отходов"
                    @click="zoomToPoint(openedRoute.endPoint)"
                  )
                    td.routes__table-col
                      img(:src="OROImage" style="width:20px")
                    td.routes__table-col {{openedRoute.endPoint.address}}
                    td.routes__table-col -
                    td.routes__table-col -
                    td.routes__table-col
                      button(
                        @click.stop.prevent="removeEndPoint"
                      ).reset-btn.close
        .legend.routes__legend(v-show='!openedRoute.id'
          key="routes"
          ref="legend"
          :class="showRouteLegend ? 'opened' : 'closed'"
        )
          .legend__head.routes__head
            h2.legend__title Маршруты
            button.legend__close.reset-btn(v-if="showRouteLegend" @click="showRouteLegend = !this.showRouteLegend")
            button.legend__open.reset-btn(v-else @click="showRouteLegend=!showRouteLegend")
          .legend__group.routes__group
            .legend__body.routes__body
              .routes__buttons
                button.reset-btn.button.button_add.button_icon-text.routes__add(@click.stop.prevent="addRoute()" v-if="userCanCreate")
                  span Добавить маршрут
                button.reset-btn.button.button_delete.button_icon-text.routes__delete(@click.stop.prevent="removeAllRoutes()" v-if="userCanDelete" )
                  span Удалить все
              .routes__table-wrapper
                e-perfect-scrollbar(ref="routes")
                  table.routes__table
                    thead
                      th № Маршрута
                      th Периодичность
                      th Протяженность (км)
                      th
                    tbody(
                      is="transition-group"
                      name="flip-list"
                      v-if="items && items.data.length > 0"
                    )
                      tr.routes__table-row(
                        :key="item.id + '_' + item.name"
                        v-for="item in items.data"
                        @click="openRoute(item.id)"
                      )
                        td.routes__table-col {{item.name ? item.name : ''}}
                        td.routes__table-col {{item.period_id ? getPeriodName(item.period_id) : ''}}
                        td.routes__table-col {{item.distance}}
                        td.routes__table-col
                          button(
                            @click.stop.prevent="removeRoute(item.id)"
                            v-if="userCanDelete"
                          ).reset-btn.close.routes__close
                    tbody(v-else)
                      tr
                        td(colspan=100) нет маршрутов

              .text-center
                button(
                  @click.stop.prevent="$refs.autoRoute.open()"
                  v-if="userCanCreate && hasAutoRoute"
                ).reset-btn.button.routes__button Автосоставление маршрутов
</template>

<script>
import 'leaflet'
import L from 'leaflet'
// скопировал из node_modules/leaflet-plugins/layer/tile/Yandex и добавил условие на 108 строке
import '@/assets/plugins/leaflet-plugins/layer/tile/Yandex'

import { TILE_LAYER } from '@/config/map'
import mapMixin from '@/mixins/map-mixin'
import {
  export_document,
  map as mapEndpoints,
  msn,
  tko,
  transport,
} from '@/api/api-endpoints'
import {
  NOTIFY,
  PERIODS,
  PERIOD_WEEKLY_ID,
  STATUS_ACTIVE,
  WALL,
} from '@/config/config'
import { REGION_CONFIG } from '@/config/regions'
import userFriendlyEr from '@/utils/userFriendlyEr'
import formBaseMixin from '@/components/form/form-base-mixin'
import { core } from '@/api/api-endpoints'
import hasMixin from '@/mixins/has-mixin'
import MapDangerClass from '@/app/geo/components/map-danger-class'
import MapFkko from '@/app/geo/components/map-fkko'
import { addCheckboxValue } from '@/utils/adapters'
import RoutesDrawer from './utils/RoutesDrawer'
import autoRoute from './components/auto-route'
import Route from './models/Route'
import GarageImage from '../../assets/images/icons/mps.png'
import OROImage from '../../assets/images/icons/oro.png'
import RouteObjects from './components/route-objects'
import TransportChoose from './components/transport-choose'
import MapMsn from './components/map-msn'
import SearchMsn from './components/search-msn'
import permissionMixin from '@/mixins/permission-mixin'

const ROUTE_HEIGHT = 27
const mapConfig = REGION_CONFIG.map

export default {
  name: 'appeals-map',
  components: {
    autoRoute,
    MapFkko,
    MapDangerClass,
    RouteObjects,
    MapMsn,
    TransportChoose,
    SearchMsn,
  },
  mixins: [mapMixin, formBaseMixin, permissionMixin, hasMixin],
  data() {
    this.mapLayers = null
    this.map = null
    return {
      saving: false,
      saveEnable: false,
      waitForPoint: false,
      calcEnable: false,
      addressData: {},
      openedRoute: {
        cost: 0,
        mass: 0,
        start_point_address: '',
        startPoint: {
          coords: [],
          address: '',
          data: null,
        },
        end_point_address: '',
        end_point_id: '',
        endPoint: {
          id: null,
          coords: [],
          address: '',
          data: null,
        },
        tkoPoints: [],
        tko_operator_regional_id: '',
        tko_operator_transporter_id: '',
        date_finish: null,
        date_start: null,
      },
      items: {
        data: [],
        _meta: null,
        _links: null,
      },
      page: 1,
      scrolledFromTop: 0,
      routeMsns: {},
      objectList: [],
      showTransportModal: false,
      showRouteLegend: true,
      initialMsns: [],
    }
  },
  computed: {
    collections() {
      return (
        this.$store.getters.readUrlEndpoint(this.getCollectionEndpoint()) || {}
      )
    },
    conditions() {
      return {
        noStartPoint:
          this.openedRoute &&
          !this.openedRoute.startPoint?.hasOwnProperty('coords'),
        noPointsAtAll: Object.keys(this.routeMsns).length < 1,
        oneOrLessPoints: Object.keys(this.routeMsns).length <= 1,
        onlyStartPoint:
          this.openedRoute.startPoint && Object.keys(this.routeMsns).length < 1,
        onlyStartAndEndPoints:
          this.openedRoute.startPoint &&
          this.openedRoute.endPoint !== undefined &&
          this.openedRoute.endPoint?.hasOwnProperty('coords'),
        minimumTwoPointsSelected: Object.keys(this.routeMsns).length > 1,
        startPointAndAnother:
          this.openedRoute.startPoint?.hasOwnProperty('coords') &&
          Object.keys(this.routeMsns).length === 1,
      }
    },
    routePointList() {
      return Object.values(this.routeMsns)
    },
    routeTkoList() {
      return this.openedRoute.tkoPoints
    },
    isCalcEnabled() {
      let c = this.conditions
      return (
        c.onlyStartAndEndPoints ||
        c.startPointAndAnother ||
        c.minimumTwoPointsSelected
      )
    },
    isSaveEnabled() {
      let c = this.conditions
      return (
        c.minimumTwoPointsSelected ||
        c.startPointAndAnother ||
        c.onlyStartAndEndPoints
      )
    },
    GarageImage() {
      return GarageImage
    },
    OROImage() {
      return OROImage
    },
    /**
     * @return {number}
     */
    PERIOD_WEEKLY() {
      return PERIOD_WEEKLY_ID
    },
    PERIODS() {
      return PERIODS
    },
    routePeriods() {
      return this.collections.route_period
    },
    weekDays() {
      return this.collections.weekday
    },
    msns() {
      return this.$store.getters.readUrlEndpoint(this.getMSINAddresses())
    },
    STATUS_ACTIVE() {
      return STATUS_ACTIVE
    },
    mapBorders() {
      return this.$store.getters.readUrlEndpoint(
        mapEndpoints.heatMapRegOperators(
          this.$route.query.zoom || mapConfig.zoom
        )
      )
    },
    tkoObjects() {
      return this.$store.getters.readUrlEndpoint(this.getTKOObjects()).data
    },
    tkoOperators() {
      return this.$store.getters.readUrlEndpoint(this.getOperators()).data
    },
    tkoRegionalOperators() {
      return this.$store.getters.readUrlEndpoint(this.getRegionalOperators())
        .data
    },
    msnSearchType() {
      return this.hasRouteMsnSearchType ? 'container_type' : 'container'
    },
  },
  methods: {
    getCollectionEndpoint() {
      return core.collection('route_period,weekday')
    },
    onSelectAddress({ data, value }) {
      this.$set(this.openedRoute, 'start_point_address', value)
      this.$set(this.openedRoute, 'startPoint', {
        coords: [+data.geo_lat, +data.geo_lon],
        data,
      })
      if (this.openedRoute.endPoint?.coords.length < 1) {
        this.showMsg('Выберите место размещения отхода')
      }
      if (this.isCalcEnabled) {
        this.calcEnable = true
      }
    },
    calcRoute() {
      this.reCalcRoute().then(() => {
        this.waitForPoint = false
        this.routesDrawer.waitForPoint = false
      })
    },
    zoomToPoint(point) {
      const { latitude, longitude, coords } = point
      if (latitude && longitude) {
        this.map.setView([latitude, longitude], 16)
      } else if (Array.isArray(coords)) {
        this.map.setView(coords, 16)
      }
    },
    scrollToBottom() {
      if (this.$refs.routes) {
        this.$refs.routes.setScrollTop(999999)
      } else if (this.$refs.points) {
        this.$refs.points.setScrollTop(999999)
      }
    },
    async routesGenerated(routes) {
      this.$bar.start()
      this.$refs.autoRoute.freeze()
      await this.batchCreateRoute(routes)
        .then(async () => {
          await this.fetchData().then(() => {
            this.scrollToBottom()
            this.showOnSuccess('Новые маршруты сформированы')
          })
        })
        .catch((e) => {
          console.error(e)
          this.onError(e)
        })
        .finally(() => {
          this.$bar.finish()
          this.$refs.autoRoute.close()
        })
    },
    async batchCreateRoute(routes) {
      let lastNumber = this.getNextRouteNumber()
      for (let i = 0; i < routes.length; i++) {
        let route = await this.directions(routes[i])
        route.name = `${lastNumber}`
        if (route.msn) {
          for (let mIndex = 0; mIndex < route.msn.length; mIndex++) {
            route.msn[mIndex] = this.prepareMSNModel(route.msn[mIndex])
          }
        }

        await this.$store.dispatch('createModel', {
          url: transport.route(),
          data: route,
        })

        lastNumber++
      }
      return true
    },
    removeRoute(id) {
      this.confirmBox(
        'Удаленный маршрут нельзя будет восстановить',
        'Удалить маршрут?'
      ).then(() => {
        this.$bar.start()
        this.$store
          .dispatch('deleteModel', {
            url: transport.route(id),
          })
          .then(() => {
            this.showOnSuccess('Маршрут удален')
            const index = this.items.data.findIndex((item) => item.id === id)
            this.items.data.splice(index, 1)
          })
          .catch((e) => {
            console.error(e)
            this.onError(e)
          })
          .finally(() => {
            this.$bar.finish()
          })
      })
    },
    confirmBox(
      msg = 'Удаленную запись нельзя будет восстановить',
      title = 'Удалить запись?',
      confirmBtnText = 'Удалить'
    ) {
      return this.$confirm(msg, title, {
        confirmButtonText: confirmBtnText,
        cancelButtonText: 'Отмена',
        type: 'warning',
        closeOnClickModal: false,
      })
    },
    removePoint(i) {
      const model = this.routeMsns[i]
      const marker = model.marker
        ? model.marker
        : Object.values(this.routesDrawer._markers).find(
            (m) => model.id === m.options.model.id
          )
      if (!marker) {
        return
      }
      marker.setIcon(
        this.routesDrawer.markerCreator.createIconObject(
          'places',
          'container-gray'
        )
      )
      this.$delete(this.routeMsns, i)
      if (Object.keys(this.routeMsns).length) {
        const msns = Object.values(this.routeMsns)
        this.routeMsns = {}
        msns.forEach((v, i) => {
          this.$set(this.routeMsns, i, v)
        })
      }
      this.calcEnable = this.isCalcEnabled
      if (!this.calcEnable) {
        this.routesDrawer.removeRoute()
        this.showMsg(
          'В маршруте необходимо указать минимум два пункта. Добавьте пункт(ы) или закройте панель изменения маршрута, чтобы отменить изменения',
          'warning',
          NOTIFY.NOTIFY_TIMEOUT
        )
      }

      if (this.saveEnable) {
        //костыль
        this.saveEnable = false
      }
    },

    async saveRoute() {
      if (this.saving) {
        return
      }
      this.waitForPoint = false
      this.routesDrawer.waitForPoint = false
      this.$bar.start()
      this.saving = true
      try {
        const data = Object.assign({}, this.openedRoute, {
          points: this.routePointList.length
            ? this.routePointList.map((r) => {
                return { object_id: r.id, object_type: 'msn' }
              })
            : [],
        })
        data.end_point_address = this.openedRoute?.endPoint?.address
        data.end_point_id = this.openedRoute?.endPoint?.id
        if (this.openedRoute.tkoPoints && this.openedRoute.tkoPoints.length) {
          const points = this.openedRoute.tkoPoints.map((item) => {
            return { object_id: item.object_id, object_type: item.object_type }
          })
          points.push({
            object_id: this.openedRoute.endPoint.id,
            object_type: 'tko_object',
          })
          data.points = [...data.points, ...points]
        }
        await this.$store.dispatch('updateModel', {
          url: transport.route(this.openedRoute.id),
          data: data,
        })
        this.showOnSuccess('Маршрут сохранен')
        this.fetchData()

        this.saving = false
        this.$bar.finish()
      } catch (e) {
        console.error(e)
        this.saving = false
        this.onError(e)
      }
    },
    async reCalcRoute() {
      this.showWarning('Подождите, маршрут рассчитывается.')
      this.$bar.start()
      this.routesDrawer.removeRoute()

      let route = await this.directions(this.openedRoute)

      if (Object.keys(route).length > 0) {
        this.saveEnable = this.isSaveEnabled
        this.calcEnable = false
        this.openedRoute = Object.assign({}, this.openedRoute, route)
        await this.routesDrawer.drawRoute(this.openedRoute, {
          ...this.openedRoute.points,
        })
        this.$bar.finish()
        this.showOnSuccess('Маршрут рассчитан.')
      } else {
        this.onError('Расчет не удался из-за ошибки. Попробуйте еще раз')
        this.calcEnable = true
      }
      this.saveEnable = true
    },
    async putMSN(model) {
      const index = Object.keys(this.routeMsns).length
      await this.$set(this.routeMsns, index, model)
      this.calcEnable = this.isCalcEnabled
      if (this.calcEnable) {
        this.showMsg('Нажмите «Рассчитать маршрут»')
      }
    },
    redrawPoints() {
      this.$bar.start()
      this.routesDrawer.drawPoints(this.msns, this.routeMsns).then(() => {
        this.$bar.finish()
      })
    },
    async directions(inputOpenedRoute = {}) {
      let openedRoute = JSON.parse(JSON.stringify(inputOpenedRoute))
      let latlngArr = Object.values(this.routeMsns).length
        ? Object.values(this.routeMsns).map((v) => {
            return `${v.latitude || v.lat},${v.longitude || v.lng}`
          })
        : []
      const tkoObjectCoords = this.openedRoute.tkoPoints?.length
        ? this.openedRoute.tkoPoints.map((item) => {
            return `${item.latitude || item.lat},${item.longitude || item.lng}`
          })
        : []
      latlngArr = [...latlngArr, ...tkoObjectCoords]
      let startPointCoords = openedRoute.startPoint
        ? openedRoute.startPoint.coords
        : []
      let endPointCoords = openedRoute.endPoint
        ? openedRoute.endPoint.coords
        : []
      let hasStartPoint =
        startPointCoords &&
        startPointCoords.length > 1 &&
        startPointCoords[0] &&
        startPointCoords[1]
      let hasEndPoint =
        endPointCoords &&
        endPointCoords.length > 1 &&
        endPointCoords[0] &&
        endPointCoords[1]

      let query = {}
      query = {
        origin: hasStartPoint
          ? `${startPointCoords[0]},${startPointCoords[1]}`
          : latlngArr[0],
        destination: hasEndPoint
          ? `${endPointCoords[0]},${endPointCoords[1]}`
          : latlngArr[latlngArr.length - 1],
      }
      const queryString = []
      let ws = latlngArr.slice()
      query.waypoints = ws.join(';')
      if (query.origin) {
        queryString.push(query.origin)
      }
      if (query.waypoints && query.waypoints.length > 0) {
        queryString.push(query.waypoints)
      }
      if (query.destination) {
        queryString.push(query.destination)
      }

      await this.$store
        .dispatch('createModel', {
          url: transport.directions,
          data: { coords: queryString.join(';') },
        })
        .then((r) => {
          if (!r.data || !r.data.routes) {
            return
          }
          let polyline = []
          let distance = r.data.distance
          let duration = r.data.duration
          // create route

          r.data.routes.legs.forEach((leg) => {
            distance = distance + +leg.distance
            duration = duration + +leg.duration
            leg.steps.forEach((step) => {
              let decoded = step.geometry.coordinates
              decoded.forEach((point) => {
                polyline.push(point)
              })
            })
          })
          openedRoute.polyline = polyline
          if (distance > 0) {
            openedRoute.distance = (distance / 1000).toFixed(3)
          }
          if (duration > 0) {
            let hours = Math.floor(duration / 60 / 60)
            let durInMin = Math.round(duration / 60 - 60 * hours)
            openedRoute.durationInSec = duration
            openedRoute.duration = `${hours} ч, ${durInMin} мин`
          }
        })
        .catch((e) => {
          console.error(e)
          return Promise.reject(e)
        })
      return openedRoute
    },
    showMsg(msg, type = 'success', duration = WALL.SUCCESS_TIMEOUT) {
      this.msgSuccess = this.$message({
        message: msg,
        type: type,
        duration,
      })
    },
    onError(e) {
      this.$message({
        message: userFriendlyEr.recognize(e),
        type: 'error',
        duration: WALL.ERROR_TIMEOUT,
      })
    },
    showOnSuccess(title = 'Действие успешно завершено') {
      this.$swal({
        position: 'center',
        type: 'success',
        title: title,
        showConfirmButton: false,
        timer: WALL.SUCCESS_TIMEOUT,
      })
    },
    showWarning(title = 'Пожалуйста, подождите!') {
      this.$swal({
        position: 'center',
        type: 'warning',
        title: title,
        showConfirmButton: false,
        timer: WALL.SUCCESS_TIMEOUT,
      })
    },
    addPoint() {
      this.waitForPoint = true
      this.routesDrawer.waitForPoint = true
      this.saveEnable = false
      this.calcEnable = this.isCalcEnabled
      if (this.calcEnable) {
        this.showMsg('Кликайте по серым маркерам, чтобы добавить новые адреса')
      }
    },
    async openRoute(id) {
      if (!this.items || !this.items.data || !this.items.data.length) {
        return
      }
      this.routeMsns = {}
      const params = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getRoute(id),
        })
      ).data

      this.$store.commit('preloaderOn', true)
      this.$store.commit('preloader', true)

      this.saveEnable = false
      this.$bar.start()

      if (this.items && this.items.data && this.items.data.length) {
        let foundRoute = this.items.data.find((r) => r.id === id)
        foundRoute = { ...foundRoute, ...params }
        const { points, ...route } = foundRoute
        this.openedRoute = Object.assign({}, this.openedRoute, route)
        this.openedRoute.tkoPoints = []
        points.forEach((m, i) => {
          if (m.object_type === 'tko_object') {
            if (i !== points.length - 1) {
              this.openedRoute.tkoPoints?.push({ ...m, object_id: m.id })
            } else {
              this.openedRoute.end_point_address = m.name
              this.openedRoute.end_point_id = m.id
            }
          }
          if (m.object_type === 'msn') {
            this.routeMsns[i] = m
          }
        })
        setTimeout(async () => {
          this.routesDrawer.removeRoute()
          await this.routesDrawer.drawRoute(
            this.openedRoute,
            this.msns,
            this.routeMsns
          )
          this.prevPostiton = {
            zoom: this.map.getZoom(),
            center: this.map.getCenter(),
          }
          this.routesDrawer.zoomToRoute()
          this.$store.commit('preloaderOn', false)
          this.$store.commit('preloader', false)
        }, 500)
        this.$bar.finish()
      }
      if (this.conditions.noStartPoint) {
        this.showMsg('Выберите начальную точку маршрута')
      }
    },
    closeRoute() {
      if (this.prevPostiton && this.prevPostiton.zoom) {
        this.map.setView(this.prevPostiton.center, this.prevPostiton.zoom)
      }
      this.waitForPoint = false
      this.routesDrawer.waitForPoint = false
      const index = this.items.data.findIndex(
        (item) => item.id === this.openedRoute.id
      )
      this.items.data.splice(index, 1, this.openedRoute)
      this.openedRoute = Object.create(null)
      this.routesDrawer.removeAll()
      this.getInitialAddresses()
      this.page = 1
      this.scrolledFromTop = 0
      this.getRoutes()
    },
    getNextRouteNumber() {
      let biggest = 0
      if (this.items && this.items.data && this.items.data.length) {
        biggest = 1
        this.items.data.forEach((v) => {
          if (v.name && +v.name > 0) {
            biggest = +v.name
          }
        })
      }
      return biggest + 1
    },
    // create new route
    addRoute() {
      this.$bar.start()
      let route = new Route()
      route.name = this.getNextRouteNumber()
      this.$store
        .dispatch('createModel', {
          url: transport.route(),
          data: route,
        })
        .then((r) => {
          let {
            data: { id },
          } = r
          this.fetchData().then(() => {
            this.scrollToBottom()
            setTimeout(() => {
              this.openRoute(id)
            }, 500)
          })
        })
        .catch((e) => {
          console.error(e)
          this.onError(e)
        })
        .finally(() => {
          this.$bar.finish()
        })
    },
    prepareMSNModel(model) {
      let containersVolumeSum = 0
      if (!model.hasOwnProperty('containers_count') && model.daily_norm) {
        model.containers_count = Math.round(model.daily_norm)
      }

      if (model.volume_count) {
        containersVolumeSum = (model.volume_count * 1).toFixed(3)
      } else if (model.containers_count) {
        containersVolumeSum = (model.containers_count * 0.75).toFixed(3)
      }
      if (isNaN(containersVolumeSum)) {
        containersVolumeSum = 0
      }
      model = { ...model, containersVolumeSum }
      return model
    },
    async onMarkerClick(evt) {
      if (!this.openedRoute || !this.openedRoute.id) {
        return
      }
      let { marker } = evt
      if (
        this.waitForPoint === true &&
        this.routesDrawer.waitForPoint === true
      ) {
        let model = Object.assign({}, marker.options.model, {
          lat: marker.options.model.latitude,
          lng: marker.options.model.longitude,
          marker,
        })
        const index = Object.values(this.routeMsns).findIndex(
          (m) => m.id === model.id
        )
        if (index === -1) {
          marker.setIcon(
            this.routesDrawer.markerCreator.createIconObject(
              'places',
              'container'
            )
          )
          const msnModel = this.prepareMSNModel(model)
          await this.putMSN(msnModel)
          if (this.msgSuccess) {
            this.msgSuccess.close()
          }
        } else {
          this.removePoint(index)
        }
      }
    },
    getMapConfig(key) {
      return mapConfig[key]
    },
    getMapPolygon() {
      return REGION_CONFIG.polygon
    },
    drawTiles() {
      L.tileLayer(TILE_LAYER, {}).addTo(this.map)
    },
    afterMapInit() {
      this.routesDrawer = new RoutesDrawer(this.map, this)
    },
    /* required for use in map-poup */
    popupIsOpened() {
      return false
    },
    /* required for use in map-poup */
    registerOpenPopup() {},
    destroyMap() {
      this.$emitter.emit('geo.destroyMap', {})
      this.map = null
    },
    perPage() {
      const scroll = this.$refs.legend
      const height = scroll.clientHeight
      return Math.floor(height / ROUTE_HEIGHT)
    },
    getItemsEndpoint() {
      return transport.routes({
        query: {
          'per-page': this.perPage(),
          page: this.page,
          fields: 'id, name, distance, period_id',
        },
      })
    },
    getRoute(id) {
      return transport.route(id)
    },
    getMSINAddresses() {
      return msn.addresses()
    },
    getTKOObjects() {
      return tko.objects(
        {
          query: { 'per-page': -1, fields: 'id,name,latitude,longitude' },
        },
        ''
      )
    },
    getOperators() {
      return tko.operators({
        query: { 'per-page': -1 },
      })
    },
    getRegionalOperators() {
      return tko.regionalOperators({
        query: { 'per-page': -1 },
      })
    },
    removeAllRoutes: async function () {
      this.$bar.start()
      try {
        if (this.items.data.length) {
          for (let i = 0; i < this.items.data.length; i++) {
            await this.$store.dispatch('deleteModel', {
              url: transport.route(this.items.data[i].id),
              data: this.items.data[i],
            })
          }
          await this.fetchData()
          this.items.data = []
        }
        this.showOnSuccess('Маршруты удалены')
      } catch (e) {
        console.error(e)
        alert(e.toString())
      } finally {
        this.$bar.finish()
      }
    },
    getExportPoint() {
      return export_document.route(this.$route)
    },
    fetchData() {
      let { asyncData } = this.$options
      this.$bar.start()
      return asyncData({
        store: this.$store,
        route: this.$route,
        methods: this,
      })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          this.$bar.finish()
        })
    },
    async getItems() {
      return await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getItemsEndpoint(),
        })
      ).data
    },
    async getRoutes() {
      this.items = await this.getItems()
      if (this.$route.params.id) {
        this.openRoute(this.$route.params.id)
      }
    },
    async scrolleRoute() {
      const scroll = this.$refs.legend
      const PADDING_FOR_LOAD = 60

      if (
        scroll.scrollTop > this.scrolledFromTop ||
        (scroll.scrollTop + PADDING_FOR_LOAD >= scroll.clientHeight &&
          this.items._meta.pageCount > this.page)
      ) {
        this.page = this.page + 1
        this.scrolledFromTop = scroll.scrollTop + scroll.clientHeight
        const newItems = await this.getItems()

        this.items.data.push(...newItems.data)
        this.items._meta = newItems._meta
        this.items._links = newItems._links
      }
    },
    updateObjects(list) {
      let currentList = null
      if (!list.length && this.objectList.length) {
        currentList = this.objectList
      }
      this.objectList = list.map((item) =>
        addCheckboxValue({ layer: item, value: true })
      )
      const shortList = list.map(({ id, name, latitude, longitude }) => {
        return {
          object_id: id,
          object_type: 'tko_object',
          name,
          latitude,
          longitude,
        }
      })
      if (!this.openedRoute.endPoint?.id) {
        const lastObject = shortList[shortList.length - 1]
        this.openedRoute.endPoint = {
          id: lastObject.object_id,
          coords: [
            lastObject.latitude || lastObject.lat,
            lastObject.longitude || lastObject.lng,
          ],
          address: lastObject.name,
        }
        shortList.pop()
      } else {
        const currentEndpointId = shortList.findIndex(
          (item) => item.object_id === this.openedRoute.endPoint.id
        )
        if (currentEndpointId !== -1) {
          shortList.splice(currentEndpointId, 1)
        }
        if (currentList && !this.objectList.length) {
          currentList.forEach((item) => {
            if (item.id === this.openedRoute.endPoint.id) {
              this.openedRoute.endPoint = {}
              this.calcEnable = false
            }
          })
        }
      }
      if (this.openedRoute.tkoPoints.length) {
        const newPoints = []
        this.openedRoute.tkoPoints.forEach((item) => {
          const elements = shortList.filter(
            (el) => el.object_id !== item.object_id
          )
          newPoints.push(...elements)
        })
        this.openedRoute.tkoPoints.push(...newPoints)
      } else {
        this.openedRoute.tkoPoints = shortList
      }

      this.calcEnable = true
    },
    removeTkoPoint(index) {
      const findedPoint = this.openedRoute.tkoPoints[index]
      this.openedRoute.tkoPoints.splice(index, 1)
      const objectItem = this.objectList.find(
        (item) =>
          item.id === findedPoint.id || item.id === findedPoint.object_id
      )
      if (objectItem) {
        objectItem.checked = false
      }

      this.calcEnable = true
    },
    removeEndPoint() {
      const objectItem = this.objectList.find(
        (item) => item.id === this.openedRoute.endPoint.id
      )
      if (objectItem) {
        objectItem.checked = false
      }
      this.openedRoute.endPoint = {}
      if (this.openedRoute.tkoPoints.length) {
        const endTkoObject =
          this.openedRoute.tkoPoints[this.openedRoute.tkoPoints.length - 1]
        this.openedRoute.end_point_address = endTkoObject.name
        this.openedRoute.end_point_id = endTkoObject.id
        this.openedRoute.tkoPoints.pop()
      }
      this.calcEnable = true
    },
    async updateMsn(list) {
      this.containers = list.map((item) => item.id)
      this.getMsnRequest()
    },
    async searchMsn(list) {
      if (!list.length) {
        list = await (
          await this.$store.dispatch('updateUrlEndpoint', {
            endpoint: msn.addressesWithRoute(this.$route),
            fromCache: false,
          })
        ).data
      }
      this.$store.commit('mutateEndpoint', {
        endpoint: msn.addresses(this.$route),
        response: { data: list },
      })
      this.redrawPoints()
    },
    changeField() {
      this.saveEnable = true
    },
    getPeriodName(id) {
      return this.routePeriods.find((item) => item.id === id)?.name
    },
  },
  created() {
    this.markerClickSubs = this.$emitter.listen('marker.click', (e) =>
      this.onMarkerClick(e)
    )
  },
  mounted() {
    this.getRoutes()
    const scroll = this.$refs.legend
    scroll && scroll.addEventListener('scroll', this.scrolleRoute)
    if (REGION_CONFIG.rosreestr_view === 'yandex') {
      this.map.addLayer(new L.LayerGroup([L.yandex()], { pane: 'yandex' }))
    }
  },
  destroyed() {
    this.markerClickSubs.unsubscribe()
  },
  asyncData({ store, route, methods }) {
    let promises = []

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getCollectionEndpoint(),
        fromCache: true,
      })
    )

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: mapEndpoints.heatMapRegOperators(
          route.query.zoom || mapConfig.zoom
        ),
        fromCache: true,
      })
    )

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getMSINAddresses(),
        fromCache: true,
      })
    )

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getTKOObjects(),
      })
    )

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getOperators(),
      })
    )

    promises.push(
      store.dispatch('updateUrlEndpoint', {
        endpoint: methods.getRegionalOperators(),
      })
    )

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  },
}
</script>
<style lang="scss">
.routes__toolbar .view-panel {
  position: static;
}
</style>
